import { render } from "./no-result.vue?vue&type=template&id=f5d83172&scoped=true"
import script from "./no-result.vue?vue&type=script&lang=js"
export * from "./no-result.vue?vue&type=script&lang=js"

import "./no-result.vue?vue&type=style&index=0&id=f5d83172&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/溯源H5正式环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d83172"]])

export default __exports__